import { FC } from 'react';

import { Styledlabel, Box, Wrapper, CalendarIcon } from './styled';

type PropsType = {
  label: string;
  rightBorder?: boolean;
  onClick?(): void;
};

const EmptyComp: FC<PropsType> = ({ label, rightBorder, onClick }) => {
  return (
    <Wrapper onClick={onClick} rightBorder={rightBorder}>
      <Styledlabel>{label}</Styledlabel>
      <Box>
        <CalendarIcon />
      </Box>
    </Wrapper>
  );
};

export default EmptyComp;
